import { Menu } from '@headlessui/react';
import { Link } from '@remix-run/react';

import { useWebThemeContext } from '~/components/Layout/Context/useWebThemeContext';
import Typography from '~/components/Typography';

interface Props {
  text: string | React.ReactNode;
  Icon?: any;
  link: {
    href: string;
    type: 'internal' | 'external';
  };
}

const DropdownLink = ({ text, Icon, link }: Props) => {
  const { webTheme: theme } = useWebThemeContext();

  if (link.type === 'external') {
    <Menu.Item>
      {/* biome-ignore lint/correctness/noUnusedVariables: Keeping for backwards compatibility */}
      {({ active }) => (
        <a
          href={link.href}
          className="flex items-center space-x-2 px-6 py-3"
          target="_blank"
          rel="nofollow noreferrer noopener"
        >
          {Icon && (
            <div
              style={{
                color: theme?.navbar_text_color,
              }}
            >
              <Icon className="h-4 w-4" />
            </div>
          )}
          <Typography
            as="span"
            className=""
            color={theme.navbar_text_color}
            weight="medium"
            fontFamilyv2={theme.navbar_font_family}
            size="sm"
          >
            {text}
          </Typography>
        </a>
      )}
    </Menu.Item>;
  }

  return (
    <Menu.Item>
      {/* biome-ignore lint/correctness/noUnusedVariables: Keeping for backwards compatibility */}
      {({ active }) => (
        <Link to={link.href} className="flex items-center space-x-2 px-6 py-3">
          {Icon && (
            <div
              style={{
                color: theme?.navbar_text_color,
              }}
            >
              <Icon className="h-4 w-4" />
            </div>
          )}
          <Typography
            as="span"
            className=""
            color={theme.navbar_text_color}
            weight="medium"
            fontFamilyv2={theme.navbar_font_family}
            size="sm"
          >
            {text}
          </Typography>
        </Link>
      )}
    </Menu.Item>
  );
};

export default DropdownLink;
